import { Box, Stack, Typography } from "@mui/material"
import log from "loglevel"
import React, { ErrorInfo } from "react"
import { currentEnv } from "../utils/EnvUtils"

interface State {
    hasError: boolean
    error?: Error
}

interface Props {
    children?: React.ReactNode
    fallback?: React.ReactNode
    disableNexusIcon?: true
}

export class ErrorBoundary extends React.Component {
    state: State = { hasError: false }

    constructor(public props: Props) {
        super(props)
    }

    static getDerivedStateFromError(error: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        log.error("Uncaught Error:", error, errorInfo.componentStack)
    }

    render() {
        if (this.state.hasError) {
            const showError = currentEnv !== "PROD"

            return (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    {!this.props.disableNexusIcon && (
                        <Box
                            component={"img"}
                            alt={"Nexus Icon"}
                            src={"/icon-256.png"}
                            sx={{ maxHeight: 192, maxWidth: 180, pr: 2 }}
                        />
                    )}
                    <Stack spacing={2} sx={{ width: 400 }}>
                        {this.props.fallback ?? (
                            <Box>
                                <Typography variant="h5" sx={{ pb: 2 }}>
                                    Uh oh! Something went terribly wrong
                                </Typography>
                                <Typography>
                                    Try refreshing or logging out. If the error persists please try contacting an admin.
                                </Typography>
                            </Box>
                        )}
                        {showError && (
                            <Box>
                                <Typography display={"inline"} fontWeight={"bold"}>
                                    Error:
                                </Typography>{" "}
                                <Typography display={"inline"}>{this.state.error?.message}</Typography>
                            </Box>
                        )}
                    </Stack>
                </Box>
            )
        }

        return this.props.children
    }
}
